/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";

const ResourceUsage = function (nodeId) {

    async function getInfo() {
        return callWSFunction("resources.usage.getInfo", {
            nodeId: nodeId
        })
    }

    async function listAll() {
        return callWSFunction("resources.usage.listAll", {})
    }

    return {getInfo, listAll}
}

export {ResourceUsage}